import CartQuery from "theme/pages/Cart/CartQuery.gql";
import CartQtyQuery from "theme/layouts/Header/CartQtyQuery.gql";

/**
 * @function optionsAreSet
 * @param {any} props
 */
/**
 * @callback addToCartCallback
 * @param {any} props
 */
/**
 * @callback onUpdate
 * @param {any} reponse the mutation's response
 */

/**
 *
 * @param {any} props
 * @param {any} variables for the mutation
 * @param {graphql} AddToCartMutation
 * @param {addToCartCallback} [addToCartCallback] callback for the mutation
 * @param {optionsAreSet} [optionsAreSet] function for options control
 * @param {onUpdate} [onUpdate] trigger component specific actions on the mutation's callback
 * @returns Mutation definition
 */
const createAddToCartMutationDefinition = ({
  props,
  AddToCartMutation,
  variables,
  optionsAreSet,
  addToCartCallback,
  onUpdate,
}) => {
  if (!optionsAreSet) {
    optionsAreSet = () => false;
  }
  if (!addToCartCallback) {
    addToCartCallback = () => {};
  }
  return {
    options: {
      mutation: AddToCartMutation,
      variables: variables,
      update: (store, { data: addItemToCart }) => {
        const response = addItemToCart.addItemToCart;

        if (onUpdate) {
          onUpdate(response);
        }

        if (response.success) {
          const cart = response.cart;
          store.writeQuery({
            query: CartQtyQuery,
            data: {
              cart: {
                id: cart.id,
                items_qty: cart.items_qty,
                __typename: cart.__typename,
              },
            },
          });

          store.writeQuery({
            query: CartQuery,
            data: { cart: cart },
          });
        }
      },
    },
    callback: addToCartCallback(props, variables),
    preconditionFailed: optionsAreSet(props),
  };
};

export default createAddToCartMutationDefinition;
